import type { FictionalRule, FictionalRuleFormValues } from "../../models/rulesFictional";
import type { AnyAdminRulesTabConfig, AdminRulesTabConfig } from "./types";
import { ficticiosTabConfig } from "./configs/ficticiosTabConfig";
import { featuredBadgeTabConfig } from "./configs/featuredBadgeTabConfig";
import { eventAdvancedConfigTabConfig } from "./configs/eventAdvancedConfigTabConfig";

/** @public Configuración de pestaña registrada en el motor de reglas. */
export type RegisteredAdminRulesTabConfig = AdminRulesTabConfig<
  FictionalRule,
  FictionalRuleFormValues
>;

/**
 * @public
 * Registry de pestañas del motor de reglas.
 * Para agregar una pestaña: registrar su `AdminRulesTabConfig` y su panel de datos.
 */
export const defaultTabRegistry: ReadonlyArray<AnyAdminRulesTabConfig> = [
  ficticiosTabConfig as unknown as AnyAdminRulesTabConfig,
  featuredBadgeTabConfig as unknown as AnyAdminRulesTabConfig,
  eventAdvancedConfigTabConfig as unknown as AnyAdminRulesTabConfig,
];

export const getEnabledTabs = (
  tabs: ReadonlyArray<AnyAdminRulesTabConfig> = defaultTabRegistry
) => tabs.filter((tab) => tab.enabled);

export const getVisibleTabs = (
  tabs: ReadonlyArray<AnyAdminRulesTabConfig> = defaultTabRegistry
) => tabs.filter((tab) => tab.enabled || tab.comingSoon);
